import type { Messages } from '../catalogue.en'

/**
 * The review of a recognized laboratory draft as rows under their print: the
 * crops, report dates, codes and their automatic mark, Needs attention, the
 * unsaved-edits question, and a confirmed report's provenance.
 */
export const laboratoryReview: Partial<Messages> = {
  'lab.review.reportGroup': 'טופס {number}',
  'lab.review.collectionDate': 'איסוף: {when}',
  'lab.review.resultDate': 'תוצאה: {when}',
  'lab.review.dateMissing': 'יש להזין תאריך איסוף או תאריך תוצאה',
  'lab.review.individualDates': 'תאריכים אישיים',
  'lab.review.editDates': 'עריכת תאריכי הבדיקה',
  'lab.review.inheritDates': 'שימוש בתאריכי הטופס',
  'lab.review.catalogTitle': 'בחירת בדיקת מעבדה',
  'lab.review.catalogMore': 'טעינת קודים נוספים',
  'lab.review.codingChoose': 'בחירת קוד',
  'lab.review.codingChange': 'החלפת קוד',
  'lab.review.automatic': 'אוטומטי',
  'lab.review.automaticDetail':
    'הקוד נבחר אוטומטית. אישור הדוח מקבל אותו; כדי להחליף, בחרו קוד אחר.',
  'lab.review.codingSearch': 'חיפוש בקטלוג המעבדה',
  'lab.review.codingClear': 'הסרת הקוד',
  'lab.review.suggestions': 'קודים מוצעים',
  'lab.review.attentionConfidence': 'זוהה בביטחון נמוך',
  'lab.review.attentionUnmapped': 'אין קוד מהקטלוג',
  'lab.review.attentionAutomatic': 'הקוד האוטומטי אינו ודאי',
  'lab.review.attentionUnplaced': 'לא נמצא בעמוד',
  'lab.review.cropOpen': 'פתיחת עמוד {page} עם השורה מסומנת',
  'lab.review.cropMissing': 'לא נמצא בעמוד {page}. פתיחת העמוד',
  'lab.review.cropUnavailable': 'לא ניתן להציג את עמוד {page}',
  'lab.review.page': 'עמוד {page}',
  'lab.review.addedRows': 'שורות שנוספו',
  'lab.review.filterLabel': 'שורות מוצגות',
  'lab.review.filterAll': 'כל השורות: {count}',
  'lab.review.filterAttention': 'דורשות תשומת לב: {count}',
  'lab.review.attentionNone': 'אין שורות שדורשות תשומת לב.',
  'lab.review.unsavedIntent': 'עריכות בתוצאות מעבדה שזוהו',
  'lab.review.provenanceTitle': 'מקור הדוח',
  'lab.review.provenanceSource': 'מקור: {name}',
  'lab.review.provenancePages': 'מקור: {name}, עמודים {pages}',
  'lab.review.provenancePagesOf': 'מקור: {name}, עמודים {pages} מתוך {count}',
  'lab.review.provenanceOpen': 'פתיחה',
  'lab.review.provenanceRecognized': 'זוהה ב-{when}',
  'lab.review.provenanceRecognizedBy': 'זוהה ב-{when} על ידי {who}',
  'lab.review.provenanceGoogle': 'Google Document AI',
  'lab.review.provenanceConfirmed': 'אושר ב-{when}',
  'lab.review.provenanceConfirmedBy': 'אושר ב-{when} על ידי {who}',
  'lab.review.provenanceReplaced': 'החליף את הדוח מ-{when} (זיהוי חוזר)',
  'lab.review.reRecognized': 'הוחלף בזיהוי חוזר של אותו מסמך',
}
